import { IStampObject } from "../../../../../domain/editableFormat/objects";
import { IStampObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { RectangleCoordinatableObjectTranslator } from "./base";

export class StampObjectTranslator extends AbstractObjectTranslator<IStampObject, IStampObjectBean> {
  constructor() {
    super(new RectangleCoordinatableObjectTranslator());
  }

  protected shouldRecordName(source: IStampObjectBean): boolean {
    return true;
  }

  overwriteObject(source: IStampObject, bean: IStampObjectBean, formatId: number): void {
  }

  overwriteBean(source: IStampObjectBean, object: IStampObject): void {
    source["@edit"] = "1";
    source["@user-id"] = "";
  }
}
